import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Box, Card, MenuItem, Typography, Select, InputLabel, TextField, Button, FormControl, FormHelperText } from "@mui/material";
import { useSnackbar } from "notistack";
import logo from "images/logo.png";
import "modules/authentication/forgot/forgot.scss";
import {
  apiPaths,
  getAdminData,
  postData,
} from "modules/platform-components/api-integration-util";

import { forgetSchema } from "./helper";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: "100%",
    height: 50,
    textTransform: "capitalize",
  },
  back: {
    color: "#3366FF",
    fontSize: 14,
    cursor: "pointer",
  },
  errorMessage: {
    width: "100%",
    "& > p": {
      color: "red",
    },
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedTenantId, setSelectedTenantId] = useState("");
  const [tenantIds, setTenantIds] = useState([]);

  const { register, handleSubmit, errors }: any = useForm({
    validationSchema: forgetSchema,
  });

  const [message, setMessage] = useState("");


  const onSubmit = async (data) => {
    try {
      postData(`${apiPaths.forgotPassword}?userEmail=${data?.email}`, { headers: {tenantid: selectedTenantId} })
        .then((res) => {
          enqueueSnackbar("Successfully sent email", {
            variant: "success",
          });
          handleBack();
        })
        .catch((val) => {
          setMessage(val ?? "An error occurred. Please try again later.");
        });
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
    }
  };
  const fetchTenantData = useCallback(async () => {
    try {
      const response = await getAdminData(apiPaths.getTenants);
      setTenantIds(response.result);
      if(response.result.length > 0) {
        setSelectedTenantId(response.result[0].tenantId);
      }
    } catch (error) {
      console.error("Error fetching QB data:", error);
    }
  }, []);

  useEffect(() => {
    fetchTenantData();
  }, [fetchTenantData]);
  const handleTenantChange = (e) => {
    setSelectedTenantId(e.target.value);
  }

  const handleBack = () => history.push("/login");

  return (
    <Box className="forgot-wrapper">
      <Card className="card-wrapper">
        <div className="card-inner inner-logo">
          <img src={logo} style={{ width: 80, height: 80 }} alt="arise" />
          <h1 className="welcome-heading">Academic Portal</h1>
          <p style={{ color: '#8492a6', fontSize: 13, margin: '4px 0 0', fontFamily: "'Inter', 'Lato', sans-serif" }}>Reset your password</p>
        </div>
        <div className="card-inner inner-form">
        <FormControl className={classes.formControl}>
            <InputLabel>Institute</InputLabel>
            <Select
              value={selectedTenantId}
              label="Institute"
              onChange={handleTenantChange}
              variant="outlined"
              name="Institute"
            >
              {tenantIds.map((tenantId: any) => (
                 <MenuItem value={tenantId.tenantId}>{tenantId.tenantName}</MenuItem>
              ))}
            </Select>
          </FormControl> 
          <FormControl className={classes.formControl}>
            <TextField
              variant="outlined"
              type="email"
              name="email"
              label="Email"
              inputRef={register}
              error={!!errors?.email}
              helperText={errors?.email?.message}
            />
          </FormControl>
          <Box
            display="flex"
            justifyContent="flex-end"
            className={classes.errorMessage}
          >
            {message && <FormHelperText>{message}</FormHelperText>}
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleSubmit(onSubmit)}
          >
            Forgot password
          </Button>
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Typography onClick={handleBack} className={classes.back}>
              Back to login
            </Typography>
          </Box>
        </div>
      </Card>
    </Box>
  );
};

export default ForgotPassword;
